import moment from "moment";
import { InputText } from "primereact/inputtext";
import { monthShortNames } from "./Settings";

export const DEFAULT_TIMEZONE = "America/New_York";

export const formatDate = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY") : null;
};

// date template without utc
export const formatMonthWithoutUtc = function (date: any) {
  return date ? moment(date).format("DD MMM YYYY") : null;
};

// extract month
export const formatMonth = function (date: any) {
  return date ? moment.utc(date).format("MMM") : null;
};

export const formatMonthYear = function (date: any) {
  return date ? moment.utc(date).format("MMM YYYY") : null;
};

// month year template without utc
export const formatMonthYearUtc = function (date: any) {
  return date ? moment(date).format("MMM YYYY") : null;
};

export const formatDateTime = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY, hh:mm A") : null;
};

// return number of days in current month
export const daysInCurrentMonth = function () {
  const now = new Date();
  const year = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  return new Date(year, currentMonth, 0).getDate();
};

//Date Convert To YYYY/MM/DD
export function convertDateFrom(date: any) {
  if (!date) return "";
  return moment(date).format("YYYY-MM-DD");
}

// global datatable name filter
export const globalNameFilterTemplate = (options: any) => {
  const filterFieldPlaceholder = options.field
    .split("_")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return (
    <InputText
      value={options.value || ""}
      onChange={(e) => options.filterCallback(e.target.value)}
      placeholder={"Search by " + filterFieldPlaceholder}
      className="p-column-filter"
    />
  );
};

//Date Convert
export function convertDate(date: any) {
  date = new Date(date); //Date pass
  let day = date.getDate();
  let month = date.getMonth();
  let year = date.getFullYear();

  return monthShortNames[month] + " " + (day <= 9 ? "0" + day : day) + "," + " " + year;

  // return (day <= 9 ? '0' + day : day) + '-' + ( monthShortNames[month]) + '/' + year;
}
